/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authServiceAccountsRegenerateApiKey } from "../../funcs/authServiceAccountsRegenerateApiKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RegenerateServiceAccountApiKeyRequest$inboundSchema,
};

export const tool$authServiceAccountsRegenerateApiKey: ToolDefinition<
  typeof args
> = {
  name: "auth-service-accounts-regenerate-api-key",
  description: `Rotate a service-account API key's secret`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authServiceAccountsRegenerateApiKey(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
